<template lang="pug">
.dialogue-wrapper
    .overlay-close(@click="$close(false)")

    .modal.modal__small
        .modal-wrapper
            .modal-main

                .modal-body {{ content }}

                .modal-footer
                    .footer-content.l-flex-row--between
                        .btn.btn--medium(
                            @click="$close(noValue)"
                        ) {{ no }}

                        .btn.btn--medium.btn-rev(
                            @click="$close(yesValue)"
                        ) {{ yes }}
</template>

<script>
export default {
    name: 'GlobalDialog',

    props: {
        content: {
            type: String,
            required: true
        },
        yes: {
            type: String,
            default: 'Continue'
        },
        yesValue: {
            type: Boolean,
            default: true
        },
        no: {
            type: String,
            default: 'Cancel'
        },
        noValue: {
            type: Boolean,
            default: false
        }
    }
}
</script>